import clsx from 'clsx';
import type { PrefetchMode } from '@//hooks/useLinkPrefetch';
import { AppLink } from '../AppLink';
import styles from './Link.module.scss';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  title?: string;
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
  /** Prefetch policy. Default 'none' — explicit opt-in required. */
  prefetch?: PrefetchMode;
}

// Styled inline link wrapping AppLink. AppLink already short-circuits to a
// plain <a> for hash anchors, mailto/tel/sms, and external absolute URLs —
// so this stays a thin styling layer.
export const Link: React.FC<LinkProps> = ({
  href,
  title,
  ariaLabel,
  children,
  className,
  prefetch,
  ...props
}) => (
  <AppLink
    href={href}
    title={title}
    aria-label={ariaLabel}
    prefetch={prefetch}
    {...props}
    className={clsx(styles.link, className)}
  >
    {children}
  </AppLink>
);
